import { IpInfoSuccessResponse } from '@monoimin/sb-types';

import { jsonParse } from '../helpers';
import { getUrlOrigin } from '../helpers/getUrlOrigin';
import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '../storage/sessionStorage';

const onFetchFailure = () => {
  return null;
};
const onFetchSuccess = (res: Response) => {
  if (res.ok) {
    return res.json();
  }

  return null;
};

export const getIpInfoCached = async () => {
  const storedIpInfo: IpInfoSuccessResponse | null = jsonParse(
    getSessionStorageItem('ipInfo') || ''
  );

  if (!storedIpInfo) {
    const origin = getUrlOrigin();

    const url = `${origin}/api/ip-info`;

    const ipInfoResponse: IpInfoSuccessResponse | null = await fetch(url)
      .then(onFetchSuccess)
      .catch(onFetchFailure);

    if (!ipInfoResponse) return null;

    setSessionStorageItem('ipInfo', JSON.stringify(ipInfoResponse));

    return ipInfoResponse;
  }

  return storedIpInfo;
};
export default getIpInfoCached;
